package gr.tech.meetinggenie.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import gr.tech.meetinggenie.components.layouts.AuthPageLayout
import gr.tech.meetinggenie.models.user.USER_ROLES
import gr.tech.meetinggenie.navigation.SitePage

@Page
@Composable
fun IndexPage() {
    AuthPageLayout(
        title = "Home",
        redirectIfLoggedIn = SitePage.Meetings.route,
        requiredRoles = listOf(USER_ROLES.CONFIRMED_USER.role)
    ) {}
}
